/* eslint-disable max-len */

export const TeacherGuideIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    focusable="false"
    aria-hidden
  >
    <g id="teacher-guide">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 19H21V6C21.5523 6 22 6.44772 22 7V20C22 20.5523 21.5523 21 21 21H19.9697C18.6615 21 17.3583 20.8396 16.0891 20.5223L14 20C13.3333 20.6667 12.6667 21 12 21C11.3333 21 10.6667 20.6667 10 20L7.91088 20.5223C6.64175 20.8396 5.3385 21 4.03031 21H3C2.44772 21 2 20.5523 2 20V7C2 6.44772 2.44772 6 3 6V19ZM9.7132 4C9.90062 4 10.0843 4.05267 10.2432 4.152L12 5.25L13.7568 4.152C13.9157 4.05267 14.0994 4 14.2868 4H19C19.5523 4 20 4.44772 20 5V19H12C12.6667 18.3333 13.3333 18 14 18H18V6H14.25L12 7.5L9.75 6H6V18H10C10.6667 18 11.3333 18.3333 12 19H4V5C4 4.44772 4.44772 4 5 4H9.7132ZM11 15V16.5H7.5V15H11ZM16.5 15V16.5H13V15H16.5ZM11 11.5V13H7.5V11.5H11ZM16.5 11.5V13H13V11.5H16.5ZM9 8C9.5 8 10.5 8.5 11 9V9.5H7.5V8H9ZM16.5 8V9.5H13V9C13.5 8.5 14.5 8 15 8H16.5Z"
        fill="#1E4878"
      />
    </g>
  </svg>
);
